module.exports = __webpack_public_path__ + "img/max-file-check--json.b964783f.svg";